export const environment = {
    production: false,
    apiUrl: 'https://api-dev.archcsip.com/',
    gClientId: '612516812364-v7bmnv38c6rh5f5e71hvve9p9jtbf752.apps.googleusercontent.com',
    msClientId: '4e2e2b6e-99c8-4226-b783-2380fe0d95b2',
    msRedirectUri: "https://app-dev.archcsip.com/",
    apiKey: 'AIzaSyC3VjnGIgBlK8Ep6Wm-vVR-j1BMTMDQJpg',
};